import ModalDeleteSku from './ModalDeleteSku'

export default ModalDeleteSku
